
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "login",
      resolverType: "mutation",
      routePath: "/login",
      httpMethod: "POST",
    });
  